import API from "@/lib/httpModule";

/**
 * Get airport list
 * @returns
 */
export async function getAirports(query) {
	return API.get(`/airport`, query)
		.then(async (rs) => {
			if (rs && rs.status === 200 && rs.data) {
				const response = rs.data ?? {};
				return { success: true, data: response };
			}
		})
		.catch((errRes) => {
			return {
				success: false,
				data: {},
				errors: errRes,
			};
		});
}

/**
 * Get airport detail
 * @param {String} slug
 * @returns
 */
export async function getAirportDetail(slug) {
	return API.get(`/airport/${slug}`)
		.then(async (res) => {
			const response = res.data;
			return { success: true, data: response };
		})
		.catch((errRes) => {
			return {
				success: false,
				errors: errRes,
			};
		});
}
